import { render, staticRenderFns } from "./ListAreas.vue?vue&type=template&id=0ec0c490"
import script from "./ListAreas.vue?vue&type=script&lang=js"
export * from "./ListAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports